import { Chip } from '@mui/material';
import { grey } from '@mui/material/colors';
import React, { useMemo } from 'react';
import getIndustryColor from '~/scripts/getIndustryColor';

interface CategoryChipProps
  extends React.ComponentPropsWithoutRef<typeof Chip> {
  code?: boolean;
  industry?: string;
  hideIndustry?: boolean;
  category?: string;
  industries_id?: number;
}
export const CategoryChip = ({
  category,
  industry,
  hideIndustry,
  industries_id,
  code,
  ...chipProps
}: CategoryChipProps) => {
  const { sx, ...rest } = chipProps;
  const label = useMemo(() => {
    if (code) {
      return 'Code Search';
    }
    if (industry && category && !hideIndustry) {
      return `${industry} / ${category}`;
    }
    return category;
  }, [code, industry, category, hideIndustry]);
  return (
    <Chip
      size="small"
      label={label}
      sx={{
        backgroundColor: industries_id
          ? getIndustryColor(industries_id)
          : grey[100],
        ...sx,
      }}
      {...rest}
    />
  );
};
